import { h } from "preact";
import { Play } from "../helpers/icons";

export default function BlogCardBadge({ readTime, videoPost }) {
  if (videoPost) {
    return (
      <div className="blog-card__badge">
        <Play />
        Watch
      </div>
    );
  }

  if (readTime?.value) {
    return (
      <div className="blog-card__badge">{`${readTime.value} min read`}</div>
    );
  }

  return null;
}
